import React, {useState, useCallback} from "react";

import withStyles from '@material-ui/core/styles/withStyles';
import {
    Create,
    FormTab,
    Edit,
    TextInput,
    TabbedForm, maxLength, required,
    TopToolbar,
    Toolbar, SaveButton, DeleteButton,
    ShowButton
} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    tipo: {display: 'inline-block', width: 400, marginLeft: 8},
    pais_codigo_afip: {display: 'inline-block', width: 200, marginLeft: 8},
    pais_codigo_gestion: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const CompraCptEdit = props => {
    const classes = useStyles();

    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            <ShowButton basePath={basePath} record={data}/>
        </TopToolbar>
    );

    const redirect = (basePath, id, data) => `/Pais`;

    const CustomToolbar = props => (

        <Toolbar {...props}>
            <SaveButton
                label="Actualizar"
                transform={transform}
                submitOnEnter={false}
                disabled={props.pristine}
            />
            <DeleteButton undoable={false} redirect={redirect}/>
        </Toolbar>
    );
    const transform = data => {
        return {
            ...data
        }
    };

    const PostTitle = ({record}) => {
        return <span>Pais: {record ? `${record.pais}` : ''}</span>;
    };

    return (
        <Edit title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm>
                <FormTab label="Comprobante de Compra">
                    <TextInput label="Tipo" source="cpt_tipo" sortable={false} validate={[maxLength(10), required()]}/>
                    <TextInput label="Descripción" source="cpt_d" sortable={false} validate={[maxLength(60)]}/>
                    <TextInput label="Abrev." source="cpt_abre" sortable={false} validate={[maxLength(10)]}/>
                    <TextInput label="Letra" source="cpt_letra" sortable={false} validate={[maxLength(1)]}/>
                    <TextInput label="Sucursal" source="cpt_sucursal" sortable={false}/>
                    <TextInput label="Último Nro Usado" source="cpt_ultimo_nro_usado" sortable={false}/>
                </FormTab>
            </TabbedForm>
        </Edit>
    )
};
export default CompraCptEdit;


